import clsx from 'clsx';

type statItemT = {
  title: string;
  value: number | string | undefined | null;
  subtitle?: string;
  icon?: string;
  color?: string;
  subValue?: number | string | undefined | null;
  cardClass: string;
  subTextClass?: string;
};

type statsRowT = statItemT[];

export type StatsGridComponentPropsT = {
  stats: statsRowT;
  columns?: number;
};

const StatsGridComponent = ({stats = [], columns = 5}: StatsGridComponentPropsT) => {
  if (stats.length === 0) return null;

  // Updated grid columns classes to use full width
  const gridColsClass =
    {
      2: 'xl:grid-cols-2 2xl:grid-cols-2 lg:grid-cols-2',
      3: 'xl:grid-cols-3 2xl:grid-cols-3 lg:grid-cols-3',
      4: 'xl:grid-cols-4 2xl:grid-cols-4 lg:grid-cols-4',
      5: 'xl:grid-cols-5 2xl:grid-cols-5 lg:grid-cols-5',
      6: 'xl:grid-cols-6 2xl:grid-cols-6 lg:grid-cols-6',
    }[columns] || 'xl:grid-cols-4 2xl:grid-cols-4 lg:grid-cols-4';

  return (
    <div className={clsx(`grid h-full w-full grid-cols-1 gap-2 md:grid-cols-2`, gridColsClass)}>
      {stats.map(
        (stat, index) =>
          stat.value !== undefined &&
          stat.value !== null && (
            <div key={index} className="h-full w-full !text-white">
              <div className={clsx('box !mb-0 h-full w-full !bg-primary', stat.cardClass)}>
                <div className="box-body h-full !px-4 !py-2">
                  <div className="flex h-full flex-col justify-between">
                    <div className="flex w-full items-start">
                      {stat.icon && (
                        <div className="me-4 flex-shrink-0">
                          <span className={`avatar bg-${stat.color} !text-white`}>
                            <i className={stat.icon + ' text-[1.125rem]'}></i>
                          </span>
                        </div>
                      )}
                      <span className="block truncate !p-0 font-semibold !text-white dark:text-white/50">
                        {stat.title}
                      </span>
                    </div>
                    <div className="flex flex-grow flex-col items-center justify-center">
                      <h5 className="text-[1.25rem] font-semibold">{String(stat.value)}</h5>
                    </div>
                    {stat.subtitle && (
                      <div className="items-left flex w-full justify-start">
                        <p className="!m-0 truncate !p-0">
                          <span
                            className={`badge bg-${stat.color}/10 text-${stat.color} !p-0 !pr-1 ${stat.subTextClass}`}
                          >
                            {stat.subtitle}
                          </span>
                          {stat.subValue && (
                            <span className={`font-badge bg-${stat.color}/10 text-${stat.color} !p-0 !pr-1`}>
                              {stat.subValue}
                            </span>
                          )}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default StatsGridComponent;
